import * as React from 'react';
import {Modal} from "../../Modal";
import Button from "../../Button";
import './CreateEditFillerImageModal.css';
import { IFillerImage } from '../../../infrastructure/interfaces'
import { ImageFileTypes } from '../../../infrastructure/ImageFileTypes'
import { contentImagesRelativePath } from '../../../constants';

export interface CreateEditFillerImageProps {
    show: boolean;
    onClose: any;
    fillerImage?: IFillerImage;
    editFillerImage(fillerImage: IFillerImage, formData?: FormData): void
    createFillerImage(iconName: string, formData: FormData): void;
}

export interface CreateEditFillerImageState {
    //Form State
    formData?: FormData;
    fillerImageName: string;
    hasRequiredFields: boolean;
}

export default class CreateEditFillerImageModal extends React.Component<CreateEditFillerImageProps, CreateEditFillerImageState> {

    constructor(props: any) {
        super(props);

        this.state = {
            formData: undefined,
            fillerImageName: (props.fillerImage) ? props.fillerImage.name : '',
            hasRequiredFields: false,
        };
        this.onSave = this.onSave.bind(this);
    }

    componentWillReceiveProps(nextProps: any) {
        var newIconName = (nextProps.fillerImage) ? nextProps.fillerImage.name : '';
        this.setState({
            fillerImageName: newIconName,
            hasRequiredFields: newIconName.length > 0
        });
    }

    updateFillerImage = () => {

        if (this.props.fillerImage && this.props.fillerImage.id) {
            if (this.props.editFillerImage) {
                const updatedFillerImage: IFillerImage = {...this.props.fillerImage, name: this.state.fillerImageName}
                this.props.editFillerImage(updatedFillerImage, this.state.formData);
            }
        } else {
            if (!this.state.formData) {
                return;
            }
            if (this.props.createFillerImage) {
                this.props.createFillerImage(this.state.fillerImageName, this.state.formData);
            }
        }
    }

    handleChangeFillerImage(selectorFiles: FileList | null)
    {
        if (selectorFiles != null) {
            for (var key in selectorFiles) {
                var formData = new FormData();
                formData.set(ImageFileTypes.FILLER_IMAGE, selectorFiles[key]);
                this.setState({formData},
                    () => this.hasValidFields());
                break;
            }
        }
    }

    onSave() {
        this.updateFillerImage();
        this.props.onClose();
    }

    handleInputGroupChange(newIconName: string) {
        this.setState({
            fillerImageName: newIconName
        }, () => this.hasValidFields());
    }

    hasValidFields() {
        const hasValidText = (this.state.fillerImageName.length > 1);
        const hasValidImages = (this.props.fillerImage)
            ? true
            : (
                (this.state.formData != undefined)
                && (this.state.formData.get(ImageFileTypes.FILLER_IMAGE) != null)
            )
        this.setState({ hasRequiredFields: (hasValidText && hasValidImages) });
    }

    closeModal() {
        this.setState({
            fillerImageName: '',
        });
        this.props.onClose();
    }

    render() {
        return (
            <Modal show={this.props.show}
        onClose={() => {this.closeModal();}}
    >
        <Modal.Header>
            <Modal.Title>
                <h5>
                    {this.props.fillerImage ? this.props.fillerImage.name : 'Upload Filler Image'}
        </h5>
        </Modal.Title>
        <Button bsClass="close" onClick={() => {this.closeModal();}}></Button>
        </Modal.Header>
        <Modal.Body>
        <div className="fillerImageContainer">
        <div className="fillerImageInputContainer">
            <div>
                <b>Icon Name:  </b>
        <input
        placeholder="Icon Name"
        maxLength={100}
        value={this.state.fillerImageName}
        onChange={e => {
            this.handleInputGroupChange(e.target.value);
        } }/>
        </div>
        </div>

        <div className="fillerImageInputContainer">
            <label>
                <b>Image</b>
            </label>
        {
            (this.props.fillerImage)
                ? <div className="fillerImageImageContainer"><img className="editImageModalImage" src={contentImagesRelativePath + this.props.fillerImage.src} /></div>
        : <div></div>
        }
        <input type="file"
        className="filepond"
        multiple={false}
        onChange={(e) => this.handleChangeFillerImage(e.target.files)} />
        </div>
        </div>
        </Modal.Body>
        <Modal.Footer>
        <Button bsClass="cancel" onClick={() => {this.closeModal();}}>
        Cancel
        </Button>
        <Button
        bsClass="primary"
        disabled={!this.state.hasRequiredFields}
        onClick={() => {
            this.onSave();
        }}
    >
        Save Changes
        </Button>
        </Modal.Footer>
        </Modal>
    );
    }
}



// WEBPACK FOOTER //
// ./src/components/Modals/CreateEditFillerImageModal/CreateEditFillerImageModal.tsx